import { useDispatch, useSelector } from 'react-redux'
import { I18n } from 'react-redux-i18n'
import { Element } from '../../../../common/html/element'
import { SCREEN } from '../../../../common/selectCurrencyUnit/constant'
import {
  changeCurrency,
  changeUnit,
} from '../../../../common/selectCurrencyUnit/slice'
import { useFormatCurrency } from '../../../../common/selectCurrencyUnit/useFormatCurrency'
import { Table } from '../../../../common/table'
import { CLASS_HIDE_TABLE_PDF } from '../../../../utils/common'
import { selectDataDynamicReport } from '../store/slice'
import { FirstThRow } from './FirstThRow'
import { TdCell } from './TdCell'
import { ThCell } from './ThCell'
import { TABLE_HEAD } from './helper'

export const DynamicReportTable = ({
  fsType = 'balanceSheets',
  currency,
  unit,
}) => {
  const dispatch = useDispatch()

  dispatch(
    changeCurrency({ screen: SCREEN.FINANCIAL_STATEMENT, value: currency }),
  )

  dispatch(changeUnit({ screen: SCREEN.FINANCIAL_STATEMENT, value: unit }))

  const data = useSelector(selectDataDynamicReport)

  const { formatedUnit } = useFormatCurrency(SCREEN.FINANCIAL_STATEMENT)

  const title = I18n.t(
    fsType === 'balanceSheets'
      ? 'dynamicReport.BALANCE_SHEET_2'
      : fsType === 'cashFlows'
      ? 'dynamicReport.CASHFLOW_STATEMENT_2'
      : 'dynamicReport.INCOME_STATEMENT_2',
  )

  const renderTHead = () => {
    const rowIds = Object.keys(TABLE_HEAD)
    if (fsType !== 'cashFlows') {
      rowIds.pop()
    }

    return (
      <>
        <FirstThRow fsType={fsType} columns={data.columns} />
        {rowIds.map((rowId, rowIndex) => (
          <tr
            key={rowId}
            style={{
              verticalAlign: 'baseline',
              color: '#3a414b',
              borderStyle: rowIndex === rowIds.length - 1 ? 'solid' : '',
              borderWidth: '0px 0px 1px 0px',
              borderColor: '#3a414b',
            }}
          >
            {data.columns.map((col, colIndex) => {
              return (
                <ThCell
                  key={col.colId}
                  rowId={rowId}
                  col={col}
                  colIndex={colIndex}
                />
              )
            })}
          </tr>
        ))}
      </>
    )
  }

  const schema = data.columns.map((item) => {
    const colId = item.colId
    return {
      colId,
      title: item.colId,
      tdStyle: { padding: 0, verticalAlign: 'baseline' },
      render: (_, { rowId }) => {
        return <TdCell data={data[fsType][rowId]} colId={colId} />
      },
    }
  })

  return (
    <>
      <Element
        className={CLASS_HIDE_TABLE_PDF}
        style={{ color: '#033363', fontSize: 13, fontWeight: 600 }}
      >
        <div>
          {I18n.t('dynamicReport.IN')} {formatedUnit}
        </div>
        <div className="mt1">{title}</div>
      </Element>
      <Table
        ids={Object.keys(data[fsType])}
        renderTHead={renderTHead}
        schema={schema}
        isDisplayScroll={false}
      />
    </>
  )
}
